var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7512 0.56268C3.7512 0.25192 4.00312 0 4.31388 0H7.31484C7.62559 0 7.87751 0.25192 7.87751 0.56268V1.12536H11.066C11.3768 1.12536 11.6287 1.37728 11.6287 1.68804C11.6287 1.9988 11.3768 2.25072 11.066 2.25072H0.56268C0.25192 2.25072 0 1.9988 0 1.68804C0 1.37728 0.25192 1.12536 0.56268 1.12536H3.7512V0.56268Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4929 4.27245C1.51401 4.08248 1.67458 3.93876 1.86572 3.93876H9.76298C9.95412 3.93876 10.1147 4.08248 10.1358 4.27245L10.286 5.62389C10.5566 8.0599 10.5566 10.5184 10.286 12.9544L10.2712 13.0875C10.1726 13.9747 9.48499 14.6821 8.60093 14.8059C6.75223 15.0647 4.87648 15.0647 3.02777 14.8059C2.14371 14.6821 1.4561 13.9747 1.35752 13.0874L1.34274 12.9544C1.07207 10.5184 1.07207 8.0599 1.34274 5.62389L1.4929 4.27245ZM4.87656 6.86469C4.87656 6.55393 4.62464 6.30201 4.31388 6.30201C4.00312 6.30201 3.7512 6.55393 3.7512 6.86469L3.7512 12.1164C3.7512 12.4271 4.00312 12.679 4.31388 12.679C4.62464 12.679 4.87656 12.4271 4.87656 12.1164V6.86469ZM7.87751 6.86469C7.87752 6.55393 7.62559 6.30201 7.31484 6.30201C7.00408 6.30201 6.75216 6.55393 6.75216 6.86469V12.1164C6.75216 12.4271 7.00408 12.679 7.31484 12.679C7.62559 12.679 7.87751 12.4271 7.87751 12.1164V6.86469Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.640c0b8dbac48d8422a965178c1f8864.svg";
export { ForwardRef as ReactComponent };